var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevicePurpleLarge = function SvgDevicePurpleLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.258 5.45H17.742c-2.249 0-4.072 1.715-4.072 3.83v29.44c0 2.115 1.823 3.829 4.072 3.829h12.516c2.249 0 4.072-1.714 4.072-3.829V9.28c0-2.115-1.823-3.83-4.072-3.83ZM17.742 2C13.466 2 10 5.259 10 9.28v29.44c0 4.02 3.466 7.28 7.742 7.28h12.516C34.534 46 38 42.74 38 38.72V9.28C38 5.258 34.534 2 30.258 2H17.742Z",
    fill: "#7959D3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 36,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#7959D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94 15.941a6.602 6.602 0 1 1-13.203 0 6.602 6.602 0 0 1 13.204 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.417 10.686a5.333 5.333 0 1 0 0 10.666 5.333 5.333 0 0 0 0-10.666Zm-8 5.333a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z",
    fill: "#7959D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.012 15.94a2.6 2.6 0 0 1 2.6-2.598h18.63a2.6 2.6 0 1 1 0 5.198h-18.63a2.6 2.6 0 0 1-2.6-2.6Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.691 15.941a3.92 3.92 0 0 1 3.92-3.92h18.632a3.92 3.92 0 0 1 0 7.84H24.61a3.92 3.92 0 0 1-3.92-3.92Zm3.92-1.28a1.279 1.279 0 1 0 0 2.559h18.632a1.279 1.279 0 1 0 0-2.558H24.61Z",
    fill: "#7959D3"
  })));
};
export default SvgDevicePurpleLarge;